import { jsx as _jsx } from "react/jsx-runtime";
import { SandboxIframe } from '@dixa/lib-shared-habla';
import { SafeInnerHtmlSetter } from 'components/shared/util/SafeInnerHtmlSetter';
import { getStylesheet } from 'components/shared/util/customCard';
import { cardV2 } from '../../../../../cards.types';
export const TestContent = ({ createdAt, content, cardVersion, }) => {
    // Only list response cards that currently contain `created_at` field and `card_version` is 2
    return createdAt && cardVersion === cardV2 ? (_jsx(SandboxIframe, { headContent: getStylesheet(), content: content, sandbox: `${SandboxIframe.defaultSandboxParams} allow-popups-to-escape-sandbox` })) : (_jsx(SafeInnerHtmlSetter, { element: "div", content: content, noSanitize: true }));
};
